















































































import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';
import { useFormat, useSyncQueryVariable } from '@ideavivat/vivat-2';

import useDelivery from '@/useDelivery';

import CommonTimeline from '@/components/CommonTimeline.vue';
import Loading from '@/components/Loading.vue';

import getTracking from '@/gql/delivery/getTracking.gql';
import getCompany from '@/gql/company/getCompany.gql';

const Tracking = defineComponent({
  components: {
    CommonTimeline,
    Loading,
  },
  setup() {
    const filter = reactive({
      trackingCodes: [],
    });
    const firstClick = ref(false);
    const text = useSyncQueryVariable('s', '');

    const { translate, findFarthestDeliveryStatus } = useDelivery();

    const mapStatusToTracking = (status: string) => {
      switch (status) {
        case 'PENDING_ORDER_CONFIRMATION':
        case 'ORDER_CONFIRMATION':
        case 'PENDING':
        case 'ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER':
          return 1;
        case 'PREPARE_TO_DELIVER':
          return 2;
        case 'ON_THE_WAY':
        case 'HUB':
        case 'SOME_SUCCESS':
        case 'NOT_SUCCESS':
          return 3;
        case 'ORDER_RECEIVE':
        case 'WAITING_PAYMENT':
        case 'SUCCESS':
        case 'DONE':
          return 4;
        default:
          return 1;
      }
    };

    const trackings: Ref<any> = ref([]);
    const { result: getTrackingResult, loading } = useQuery(getTracking, computed(() => ({
      trackingCodes: filter.trackingCodes,
    })), () => ({ fetchPolicy: 'network-only', clientId: 'unauthorize' }));
    const trackingResult = useResult(getTrackingResult, {}, (data) => data.tracking);
    watch(() => trackingResult.value, (newVal, oldVal) => {
      if (!loading.value && newVal !== oldVal && text.value) {
        trackings.value = trackingResult.value.map((track: any, index: number) => {
          const logs: { id: number; status: string; createdAt: string }[] = track.deliveryLogs.map((elm: any) => elm);
          logs.push({
            id: -1, status: 'PURCHASE', createdAt: track.orderDate,
          });
          const reversedDeliveryLog = logs.sort((deliveryLogs: any, dL: any) => dL.id - deliveryLogs.id);
          const deliveriesStatusLogs = logs.map((deliveryLogs: any) => deliveryLogs.status);
          deliveriesStatusLogs.push(track.status);
          const deliveryNotes = track.deliveryNote ? [
            track.deliveryNote,
            ...track.deliveryNoteLogs,
          ] : track.deliveryNoteLogs;

          const trackingStatus = mapStatusToTracking(findFarthestDeliveryStatus(deliveriesStatusLogs)) as number;
          return {
            ...track,
            deliveryNotes,
            deliveryNote: track.deliveryNote || { deliveryDate: '', vehicle: { licenses: '' } },
            deliveryLogs: reversedDeliveryLog,
            trackingStatus,
          };
        });
      }
    });

    const updateQuery = () => {
      if (text.value !== '') firstClick.value = true;
      if (text.value === '') trackings.value = [] as any;
      if (text.value && text.value?.indexOf(',') > -1) filter.trackingCodes = text.value.split(',').map((code: string) => code.trim()) as any;
      else filter.trackingCodes = text.value?.split(' ').map((code: string) => code.trim()) as any;
    };

    function dateTimeFormat(date: string) {
      return useFormat.date(date).displayFullThaiDateTime();
    }
    function dateFormat(date: string) {
      return useFormat.date(date).displayFullThaiDate();
    }

    const { result: companyResult } = useQuery(getCompany);
    const company = useResult(companyResult, { logoUrl: '/logo_generic.svg', backgroundUrl: '/img/background/bg-generic.png', name: '' }, (data: any) => data.company);

    onMounted(() => {
      updateQuery();
    });

    return {
      loading,
      filter,
      text,
      trackings,
      updateQuery,
      translate,
      firstClick,

      company,

      dateFormat,
      dateTimeFormat,

      possibleTrackingStatus: ['รับสินค้า', 'อยู่ระหว่างดำเนินการ', 'กำลังจัดส่งสินค้า', 'สินค้าจัดส่งสำเร็จ'],
      trackingStatusIcon: ['img/icons/022.svg', 'img/icons/023.svg', 'img/icons/021.svg', 'img/icons/010.svg'],
    };
  },
});

export default Tracking;
